import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';

const CultureForm = () => {
  const [TenantOptions, setTenantOptions] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const userData = JSON.parse(localStorage.getItem('@SoilAnalysis:user'));
  const userTenantID = userData.tenantID;

  const activeOptions = [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' },
  ];

  const cultures = [
    {
      label: 'Nome',
      name: 'name',
      type: 'input',
    },
    {
      label: "Código externo",
      name: "externalCode",
      type: "input",
      //disabled : isTenant,
      required: false,
    },
    {
      label: 'Empresa',
      name: 'tenantID',
      type: 'select',
      options: TenantOptions,
      visible: isVisible,
      required: true,
    },
    {
      label: 'Ativo',
      name: 'isActive',
      type: 'select',
      options: activeOptions,
    },
  ];

  const loadData = async () => {
    setIsVisible(true);

    Api.get('Tenant/getAllItems')
      .then(resultTenant => {
        if (resultTenant && resultTenant.data) {
          let options = resultTenant.data.response.map(item => ({
            value: item.tenantID,
            text: item.name,
          }));
          if (userTenantID == null) {
            options = [{ value: '', text: 'Selecione' }, ...options];
          } else {
            options = options.filter(opt => opt.value === userTenantID);
          }
          setTenantOptions(options);
        }
      })
      .catch(error => {
        exceptionNotificationAPI(error);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return TenantOptions.length > 0 ? (
    <FormCrud formName={'culture'} title={'Cultura'} fields={cultures} />
  ) : (
    <></>
  );
};

export default CultureForm;
